var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98841 3.77799L21.6203 11.0687C22.4678 11.4004 22.4678 12.5996 21.6203 12.9312L2.98841 20.222C2.19887 20.5309 1.40722 19.7788 1.67533 18.9745L3.60558 13.1837C3.7417 12.7754 4.12384 12.5 4.55427 12.5H12.0003C12.2765 12.5 12.5003 12.2761 12.5003 12C12.5003 11.7238 12.2765 11.5 12.0003 11.5H4.55425C4.12382 11.5 3.74168 11.2245 3.60557 10.8162L1.67533 5.02546C1.40722 4.22113 2.19887 3.46904 2.98841 3.77799Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsSend);
export default __webpack_public_path__ + "static/media/bsSend.05f44df801254cd4718881ec4ec8e496.svg";
export { ForwardRef as ReactComponent };